import React, { useState, useEffect } from 'react'
import './MyEvents.css'
import MyEventsCard from './MyEventsCard';
import {apiGetCurrentUser, apiGetEventById} from '../api/api.js'
import { Col, Container, Row } from 'react-bootstrap';

const MyEvents = () => {
  const [userEvent, setUserEvent] = useState([]);
  const [userEventID, setUserEventID] = useState([]);
  const [userEventImage, setUserEventImage] = useState([]);
  const getCurrentUser = () => {
    apiGetCurrentUser()
    .then((response)=> {
      const userInfo = response.data.user.eventEnrolled;
      for(let i = 0; i< userInfo.length; i++){
        apiGetEventById(userInfo[i])
        .then((res)=> {
          const eventName = res.data.content.name;
          const eventImage = res.data.content.image ? res.data.content.image:"default";
          console.log(eventImage)
          setUserEventID(userEventID => [...userEventID, userInfo[i]])
          setUserEvent(userEvent => [...userEvent, eventName])
          setUserEventImage(userEventImage => [...userEventImage, eventImage])
          })
          
        }
      })
    }
  useEffect(() => {
    getCurrentUser();
  }, []);
  const cardTotal = (userEvent == null) ? 0 : userEvent.length;
  const rowList=[];
  for(let i=0; i<cardTotal; i++){
    userEventImage[i] === "default"?
    rowList.push(
    <Col key={i} className='card-col'>
      <MyEventsCard groupName={userEvent[i]} url={userEventID[i]}/>
    </Col>)
    :
    rowList.push(
    <Col key={i} className='card-col'>
      <MyEventsCard groupName={userEvent[i]} url={userEventID[i]} imageUrl={userEventImage[i]}/>
    </Col>
    )
  }
  return (
    <Container className='MyCommunities'>
      <Row xs={'auto'} className="communities-container d-flex justify-content-start">
        <Col xs={11}>
          <h4>My Events</h4> 
        </Col>
        {rowList}
      </Row>
    </Container>
  )
}

export default MyEvents
